export default {
    'splash-start-now': 'ابدأ الآن',

    'setup-dialog-title': 'لنجهز بيئة المبيعات الخاصة بك',
    'setup-dialog-subtitle': 'سنرشدك خلال خطوات بسيطة لإعداد شركتك وفريقك، سنكون جاهزاً لننطلق!',

    'setup-step-company-title': 'إعداد بيانات شركتك',
    'setup-step-company-desc': 'أضف شعار شركتك وبياناتها الأساسية حتى تتمكن من تخصيص النظام بما يتناسب مع هويتك',

    'setup-step-business-title': 'تحديد نوع نشاطك التجاري',
    'setup-step-business-desc': 'اختر المجال الذي تعمل به لنكيّف تجربة النظام بما يناسب طبيعة عملياتك',

    'setup-step-customers-title': 'تحديد عملائك المستهدفين',
    'setup-step-customers-desc': 'اختر أنواع الجهات التي تبيع لها مثل الصيادل أو المتاجر أو الصيدليات أو غيرهم',

    'setup-step-team-title': 'بناء هيكل فريق المبيعات',
    'setup-step-team-desc': 'ابني الهيكل التنظيمي لفريقك وحدد المناصب لتسهيل الإدارة والمتابعة',

    'setup-step-products-title': 'إضافة المنتجات والرصيد الافتتاحي',
    'setup-step-products-desc': 'عرّف أصنافك وحدد الكميات المتوفرة لديك لبدء إدارة المخزون بدقة',

    'setup-step-regions-title': 'تحديد مناطق العمل',
    'setup-step-regions-desc': 'حدد المدن والمناطق التي يغطيها فريقك لتنظيم عمليات البيع والتوزيع',

    'setup-step-employees-title': 'إضافة موظفيك',
    'setup-step-employees-desc': 'أضف موظفيك لبدء العمل فوراً',

    'upload-drag-hint': 'اسحب الصورة هنا أو انقر لتحديد صورة من جهازك',
    'upload-format-note': 'بصيغة JPG أو PNG بحد أقصى 2 ميجا بايت',
    'upload-change': 'تغيير الصورة',
    'upload-remove': 'حذف الصورة',

    'system-setup-title': 'تهيئة النظام',
    'optional': '(اختياري)',

    'field-company-latin': 'اسم الشركة (اللاتينية)',
    'field-program-name': 'اسم البرنامج',
    'field-country': 'البلد',
    'field-city': 'المدينة',
    'field-english-date': 'التاريخ الإنجليزي',
    'field-phone': 'رقم الهاتف',
    'field-primary-color': 'اللون التأسيسي للنظام',
    'field-secondary-color': 'اللون الثانوي للنظام',
    'stepper-company-info': 'معلومات الشركة',
    'stepper-service-areas': 'مناطق الخدمة',
    'stepper-org-structure': 'الهيكل التنظيمي',
    'stepper-customer-types': 'أنواع العملاء',
    'stepper-business-activity': 'نشاطك التجاري',
    'stepper-other-data': 'تهيئة بيانات أخرى',
    'service-area-wholesale-title': 'البيع بالجملة',
    'service-area-wholesale-desc': 'بيع منتجات بكميات كبيرة مباشرة إلى شركات أخرى',
    'service-area-consumer-title': 'منتجات استهلاكية',
    'service-area-consumer-desc': 'منتجات تستخدم في الحياة اليومية ويتكرر شراؤها من المستهلكين بانتظام',
    'service-area-medical-title': 'الأدوية والطب',
    'service-area-medical-desc': 'المستلزمات الطبية والأدوية ومستلزمات الرعاية الصحية',
    'service-area-food-title': 'مواد غذائية ومشروبات',
    'service-area-food-desc': 'علامات الأغذية المعبأة والمشروبات والحلويات والمنتجات الغذائية',
    'service-area-other-title': 'أخرى',
    'service-area-other-desc': 'حدد نشاطاتك التجارية الأخرى إذا لم تكن ضمن الفئات المحددة',
    'customer-types-title': 'حدد أنواع زبائنك',
    'customer-type-pharmacies': 'صيدليات',
    'customer-type-medical-centers': 'مراكز طبية',
    'customer-type-wholesalers': 'تجار جملة',
    'customer-type-retail-stores': 'متسوليات',
    'customer-types-add-title': 'إضافة أنواع متاجر أخرى',
    'customer-types-add-placeholder': 'اكتب نوع متجر جديد',
    'customer-types-add-btn': 'إضافة',
    'customer-types-empty-title': 'لم تقم باختيار أي نوع من العملاء',
    'customer-types-empty-desc': 'يمكنك تخصيص أنواع العملاء الآن أو إضافتها لاحقاً من إعدادات النظام بما يتناسب مع نشاطك التجاري.',
    'btn-previous': 'السابق',
    'step-placeholder': 'سيتم تخصيص هذه الخطوة في المرحلة التالية.',
    'btn-next': 'التالي',
}
